// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3GoMo","footer":"ChangeClinic_footer__Y5rjN"};